/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */

import axios from 'axios'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'

export function compareTimes(time1, time2) {
  var date1 = new Date('1970-01-01 ' + time1);
  var date2 = new Date('1970-01-01 ' + time2);
  return date1.getTime() - date2.getTime();
}

export function compareDate(date1, date2) {
  var d1 = new Date(date1);
  var d2 = new Date(date2);
  return d1.getTime() - d2.getTime();
}

/**
 * 将分钟转换为“x小时x分钟”的格式
 * @param {*} minutes
 */
export function minutesToHoursMinutes(minutes) {
  const hours = Math.floor(minutes / 60)
  const remainingMinutes = minutes % 60
  if (hours === 0) {
      return `${remainingMinutes}分钟`;
  } else {
      if (remainingMinutes > 0) {
         return `${hours}小时${remainingMinutes}分钟`;
      }
      return `${hours}小时`
  }
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'undefined' || time === null || time === 'null') {
    return ''
  } else if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function timestampToDate(timestamp) {
  if ((typeof timestamp === 'number') && (timestamp.toString().length === 10)) {
    timestamp = timestamp * 1000
  }
  const date = new Date(timestamp) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  const Y = date.getFullYear() + '-'
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
  return Y + M + D
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i)
    if (code > 0x7f && code <= 0x7ff) s++
    else if (code > 0x7ff && code <= 0xffff) s += 2
    if (code >= 0xDC00 && code <= 0xDFFF) i--
  }
  return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString =
      classString.substr(0, nameIndex) +
      classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp
    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...newArgs) {
		args = newArgs
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = +new Date() + ''
  const randomNum = parseInt((1 + Math.random()) * 65536) + ''
  return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

// 获取html的纯文本
export function getHtmlText(htmlStr) {
	let span = document.createElement('span');
	span.innerHTML = htmlStr;
	return span.textContent || span.innerText;
}

// 替换邮箱字符
export function regEmail(email) {
  if (String(email).indexOf('@') > 0) {
    const str = email.split('@')
    let _s = ''
    if (str[0].length > 3) {
      for (var i = 0; i < str[0].length - 3; i++) {
        _s += '*'
      }
    }
    var new_email = str[0].substr(0, 3) + _s + '@' + str[1]
  }
  return new_email
}

// 替换手机字符
export function regMobile(mobile) {
  if (mobile.length > 7) {
    var new_mobile = mobile.substr(0, 3) + '****' + mobile.substr(7)
  }
  return new_mobile
}



// 下载文件
export function customDownloadFile(obj, name, suffix) {
  const url = window.URL.createObjectURL(new Blob([obj]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  const fileName = name + '.' + suffix
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

// 下载文件
export function downloadFile(obj, name, suffix) {
  const fileName = name + '-' + parseTime(new Date(), '{y}{m}{d}{h}{i}{s}')
  customDownloadFile(obj, fileName, suffix)
}

//  下载文件(通过文件路径下载)
export function downloadFileByUrl(fileUrl, name, suffix) {
	const nameSuffix = name.slice(name.lastIndexOf('.') + 1)
	if(nameSuffix == suffix) {
		name = name.slice(0, name.lastIndexOf('.'))
	}
	axios.get(fileUrl, {
		responseType: 'blob'
	}).then(res => {
		let blob = new Blob([res.data]);
		let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
		let a = document.createElement('a');
		a.href = url;
		a.download = name + '.' + suffix;
		a.click();
		window.URL.revokeObjectURL(fileUrl); // 释放该 url
	})
}
// 下载多文件到一个压缩包
// fileList 支持:
// 1. [{ fileUrl, name, suffix }, ...]
// 2. ['https://xx/a.pdf', 'https://xx/b.jpg']
export async function downloadFilesToOneZip(fileList = [], zipName = 'files') {
	if (!(fileList instanceof Array) || !fileList.length) return
	const zip = new JSZip()
	const usedFileNames = new Set()
	const getUniqueFileName = (rawName, rawSuffix, index) => {
		const baseName = (rawName || `file-${index + 1}`).toString().trim() || `file-${index + 1}`
		const suffix = (rawSuffix || 'dat').toString().replace(/^\./, '') || 'dat'
		const fullName = baseName.endsWith(`.${suffix}`) ? baseName : `${baseName}.${suffix}`
		if (!usedFileNames.has(fullName)) {
			usedFileNames.add(fullName)
			return fullName
		}
		let seq = 1
		while (usedFileNames.has(`${baseName}(${seq}).${suffix}`)) {
			seq++
		}
		const uniqueName = `${baseName}(${seq}).${suffix}`
		usedFileNames.add(uniqueName)
		return uniqueName
	}
	const taskList = fileList.map((item, index) => {
		let fileUrl = ''
		let name = `file-${index + 1}`
		let suffix = 'dat'

		if (typeof item === 'string') {
			fileUrl = item
			const pureUrl = item.split('?')[0]
			const ext = pureUrl.slice(pureUrl.lastIndexOf('.') + 1)
			if (ext && ext !== pureUrl) suffix = ext
		} else if (item && typeof item === 'object') {
			fileUrl = item.fileUrl || item.url || ''
			name = item.name || name
			suffix = item.suffix || suffix
			if (!item.suffix && fileUrl) {
				const pureUrl = fileUrl.split('?')[0]
				const ext = pureUrl.slice(pureUrl.lastIndexOf('.') + 1)
				if (ext && ext !== pureUrl) suffix = ext
			}
		}

		if (!fileUrl) return Promise.resolve()
		

		return axios.get(fileUrl, { responseType: 'blob' }).then(res => {
			zip.file(getUniqueFileName(name, suffix, index), res.data)
		})
	})

	await Promise.all(taskList)
	const blob = await zip.generateAsync({ type: 'blob' })
	saveAs(blob, `${zipName}.zip`)
}

// 下载文件(通过base64下载)
export function downloadFileByBase64(base64, name, suffix) {
	let mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
	let byteString = atob(base64.split(',')[1]); //base64 解码
	let arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
	let intArray = new Uint8Array(arrayBuffer); //创建视图
	for (let i = 0; i < byteString.length; i++) {
			intArray[i] = byteString.charCodeAt(i);
	}
	const obj = new Blob([intArray], {type: mimeString})
	customDownloadFile(obj, name, suffix)
}

export function getNodeMap(node, parentNode, childKey) {
  node.parentNode = parentNode
  const nodeMap = [node]
  if (node[childKey] && node[childKey].length) {
    node[childKey].forEach(item => nodeMap.push(...getNodeMap(item, node, childKey)))
  }
  return nodeMap
}

export function getTreeMap(tree, childKey) {
  if (!(tree instanceof Array)) return
  const treeMap = []
  tree.forEach(node => {
    treeMap.push(...getNodeMap(node, tree, childKey))
  })
  return treeMap
}

// 获取img的base64
export function getBase64Image(src) {
		return new Promise(resolve => {
			let xhr = new XMLHttpRequest()
			xhr.open('get', src, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (this.status == 200) {
					let blob = this.response
					let oFileReader = new FileReader()
					oFileReader.onloadend = function (e) {
						const base64 = e.target.result
						resolve(base64)
					}
					oFileReader.readAsDataURL(blob)
				}
			}
			xhr.send()
		})
}

// 根据文件获取base64
export function getBase64ByFile(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e) => {
      resolve(e.target.result);
    };
  });
}

// 获取图片文件的宽高
export function getFileWH(file) {
  return new Promise((resolve, reject) => {
   getBase64ByFile(file).then(res => {
		 const img = new Image();
		 img.src = res;
		 img.onload = function () {
				 resolve({width: img.width, height: img.height});
		 };
	 })
  });
}

//将json对象转为formData
export function formData(data = {}) {
  const dataform = new FormData();
  for(let key in data) {
    if(data[key] !== undefined) {
      dataform.append(key, data[key]);
    }
  }
  return dataform
}

export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()
